module.exports = __webpack_public_path__ + "static/media/south-bunbury-rotary.27996d58.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/TheMoshiDifference/south-bunbury-rotary.jpg
// module id = 184
// module chunks = 0